import { createSelector } from "reselect";
import { getFlyerDetailState } from "../../../store/flyer-detail.store";
import { IFlyerDetailState } from "../../../types/flyer-detail-state/flyer-detail-state.interface";
import Store from "../../../../../../../redux/store";
import * as actions from "./flyer-detail-add-page.actions";
import { FlyerDetailAddPageState } from "../types/flyer-detail-add-page-state/flyer-detail-add-page-state.interface";

export const getFlyerDetailAddPageState = createSelector(
  getFlyerDetailState,
  (state?: IFlyerDetailState) => state?.flyerDetailAddPageState
);

export const getTemplates = createSelector(
  getFlyerDetailAddPageState,
  (state?: FlyerDetailAddPageState) => state?.templates || null
);

export const isLoading = createSelector(
  getFlyerDetailAddPageState,
  (state?: FlyerDetailAddPageState) => state?.isLoading || false
);

export function fetchTemplates() {
  Store.dispatch(actions.fetchTemplates());
}

export function createPage(flyerId: number, templateId: number) {
  Store.dispatch(actions.createPage(flyerId, templateId));
}

export function goToFlyerDetail(flyerId: number) {
  Store.dispatch(actions.goToFlyer(flyerId));
}
